import React from "react";
import { TspBadge } from "../../../components/primitives";

export default function DashboardHeading({ banner }) {
  return (
    <div className="tsp-dashboard-heading">
      <div>
        <h1>Dashboard</h1>
      </div>
      {banner && (
        <TspBadge tone="live" className="tsp-active-journey-pill">
          <span className="tsp-live-dot" /> {banner.label}: {banner.journeyName}
        </TspBadge>
      )}
    </div>
  );
}
